import { pick } from 'ramda';
import { useTranslations } from 'js/hooks/i18n';
import React, { memo, useCallback } from 'react';

import { useGetFilterOptions } from '../../hooks';
import * as actions from '../../../../store/actions';
import { GamesFiltersPopup } from '../GamesFiltersPopup';
import { useDynamicReducerSelector, useDynamicReducerDispatch } from '../../../../store';

import style from './MobileGamesFilters.scss';

export const MobileGamesFiltersBare: React.FC = () => {
    const translate = useTranslations();
    const {
        filterLabels,
        filterCategory,
        filterProviders,
        filterCustomFields
    } = useDynamicReducerSelector(pick(['filterLabels', 'filterCategory', 'filterProviders', 'filterCustomFields']));
    const { categoryOptions } = useGetFilterOptions();
    const filterButtonCount = [
        Boolean(filterLabels),
        Boolean(filterProviders),
        Boolean(categoryOptions.filter((item) => filterCategory.split(',').includes(item.value)).length),
        ...Object.keys(filterCustomFields).map((key) => Boolean(filterCustomFields[key]))
    ].filter(Boolean).length;
    const dispatch = useDynamicReducerDispatch();

    const handleFiltersButtonClick = useCallback(() => {
        dispatch(actions.toggleFilterPopup(true));
    }, [dispatch]);

    return (
        <>
            <div onClick={handleFiltersButtonClick} className={`${style.filtersButton} cms-games-grid-mobile-filters`}>
                <div className={style.filterButtonText}>{translate('playtech.mobile.system.games-grid.filters.mobile.placeholder')}</div>
                {Boolean(filterButtonCount) && <div className={style.filterButtonCount}>{filterButtonCount}</div>}
            </div>
            <GamesFiltersPopup />
        </>
    );
};

export const MobileGamesFilters = memo(MobileGamesFiltersBare);
